module.exports = __webpack_public_path__ + "media/img/frontend_application/banner-sgbrideonthehunt2-md-2e6f17952a0aea5880edb6973531bf00.png";